import { doc, getDoc, setDoc, serverTimestamp, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';

export const DEFAULT_PORTAL_CONFIG = {
  autoActivateOnCardAttach: false,
  notifyAdminOn: 'both', // 'both' | 'activation' | 'failure' | 'none'
  adminNotificationEmail: 'roseller@fusionict.com',
};

const DOC_PATH = ['settings', 'portalConfig'];

export const getPortalConfig = async () => {
  const snap = await getDoc(doc(db, ...DOC_PATH));
  if (!snap.exists()) return { ...DEFAULT_PORTAL_CONFIG };
  return { ...DEFAULT_PORTAL_CONFIG, ...snap.data() };
};

export const subscribeToPortalConfig = (callback) => {
  return onSnapshot(doc(db, ...DOC_PATH), (snap) => {
    callback(snap.exists() ? { ...DEFAULT_PORTAL_CONFIG, ...snap.data() } : { ...DEFAULT_PORTAL_CONFIG });
  });
};

export const savePortalConfig = async (patch, uid) => {
  await setDoc(
    doc(db, ...DOC_PATH),
    {
      ...patch,
      updatedAt: serverTimestamp(),
      updatedBy: uid || null,
    },
    { merge: true },
  );
};
